<div class="container">
  <div class="row">
    <div class="col-12 my-4">
      <h1 class="mb-0 text-center fw-bold">Prospectos</h1>
    </div>
    </div>
<div class="row">
  <div class="col-12">
    <nav>
      <div class="nav nav-tabs border-0" id="nav-tab" role="tablist">
        <button class="nav-link nunito ms-3" id="nuevosProsp-tab" data-bs-toggle="tab" data-bs-target="#nuevosprosp" type="button" role="tab" aria-controls="nuevosprosp" aria-selected="true">Listado de Prospectos</button>
        <button class="nav-link nunito ms-2 active" id="extraerProsp-tab" data-bs-toggle="tab" data-bs-target="#extraerprosp" type="button" role="tab" aria-controls="extraerprosp" aria-selected="false">Extraer Prospectos</button>
        <!-- <button class="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">Contact</button> -->
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div class="tab-pane fade " id="nuevosprosp" role="tabpanel" aria-labelledby="nuevosprosp-tab">
        <div class="container">
          <div class="row py-3"> 
            <div class="col-12 mt-2 mt-md-0 col-md-2 d-flex align-items-center">
              <mat-form-field appearance="outline" class="w-100 bg-white rounded">
                <mat-label>Estados</mat-label>
                <mat-select [(ngModel)]="objBdEstado" (selectionChange)="onBdEstadoChange()">
                  <mat-option value="">--Seleccióne el estado--</mat-option>
                  <mat-option [value]="x" *ngFor="let x of arrayEstadosBd">{{x.estado}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12 mt-2 mt-md-0 col-md-2 d-flex flex-column">
                <mat-form-field appearance="outline" class="w-100 bg-white rounded">
                    <mat-label>
                      <span>
                        Municipios: {{objBdEstado && objBdEstado?.municipios?objBdEstado?.municipios?.length:0}}
                      </span>
                    </mat-label>
                    <mat-select [(ngModel)]="objBdMunicipio" >
                        <mat-option value="">{{arrayBdMunicipios.length>0 ? "TODOS": "--Seleccióne el estado--"}}</mat-option>
                        <mat-option value="option3" [value]="mun" *ngFor="let mun of arrayBdMunicipios" >{{mun.municipio}}</mat-option>
                    </mat-select>
                   <!--  <mat-icon matSuffix>location_city</mat-icon> -->
                </mat-form-field>
            </div>
            
            <div class="col-12 mt-2 mt-md-0 col-md-2">
              <mat-form-field appearance="outline" class="w-100 bg-white rounded">
                <mat-label>Busqueda por Tipo</mat-label>
                <mat-select [(ngModel)]="strBdTipo">
                    <mat-option value="">{{arrayTipos.length>0 ? "TODOS": "--Seleccióne el tipo--"}}</mat-option>
                    <mat-option value="option3" [value]="km.value" *ngFor="let km of arrayTipos" >{{km.label}}</mat-option>
                </mat-select>
                <mat-icon matSuffix>store_mall_directory</mat-icon>
              </mat-form-field>
            </div>
            <div class="col-12 mt-2 mt-md-0 col-md-2">
              <mat-form-field appearance="outline" class="w-100 bg-white rounded">
                <mat-label>Ingrese Lugar</mat-label>
                <input matInput placeholder="Ingrese Lugar" [(ngModel)]="strKeyword">
                <mat-icon matSuffix>work</mat-icon>
              </mat-form-field>
            </div>
            <div class="col-12 mt-2 mt-md-0 col-md-2">
              <mat-form-field appearance="outline" class="w-100 bg-white rounded">
                <mat-label>Kilometros</mat-label>
                <mat-select [(ngModel)]="intKm">
                    <mat-option value="">{{arrayKm.length>0 ? "TODOS": "--Seleccióne el estado--"}}</mat-option>
                    <mat-option value="option3" [value]="km.intKm" *ngFor="let km of arrayKm" >{{km.strNombre}}</mat-option>
                </mat-select>
                <mat-icon matSuffix>gps_fixed</mat-icon>
              </mat-form-field>
            </div>
            <div class="col-12 mt-2 mt-md-0 col-md-1">
              <button class="btn btn-primary d-flex align-items-center" (click)="fnGetProspectosSave()">
                <mat-icon>search</mat-icon> 
                <span>Buscar</span>  
              </button>
            </div>
          </div>
          <div class="row">
            <!-- <div class="col-2">
              <div class="col-12 d-flex mt-2">
                <button class="btn btn-primary fs11 fw-bold w-100 shadow-sm" (click)="fnBDSeleccionarTodos()"><i class="bi bi-check2-all"></i> Seleccionar todo</button>
              </div>
              <div class="col-12 d-flex mt-3">
                <button class="btn btnQuitar fs11 w-100 fw-bold shadow-sm" (click)="fnBDQuitarTodos()"><i class="bi bi-x-circle-fill"></i> Quitar selección</button>
              </div>
              <div class="col-12 d-flex flex-column  mt-3">
                <mat-form-field appearance="outline" class="bg-white rounded w-100">
                  <mat-label class="fw-bold py-0 my-0"><mat-icon>date_range</mat-icon>Agente</mat-label>
                  <mat-select [(ngModel)]="strAgente" class="fs12" >
                    <mat-option >
                      <input type="text" [(ngModel)]="searchAgent" class="form-control fs12"   placeholder="Buscar agente..."
                      (click)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                    </mat-option> 
                    <mat-option value="" class="fs12"> --Todos --</mat-option> 
                    <mat-option class="fs12" *ngFor="let x of arrayAgentes| filtersearch: searchAgent: ['strNombre']; let ind = index" [value]="x.strAgente">{{x.strNombre}}</mat-option> 
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 d-flex my-3">
                <button class="btn btnGuardar fs11 w-100 fw-bold shadow-sm" (click)="fnGuardarBDProsp()"><i class="bi bi-cloud-upload-fill"></i> Guardar</button>
              </div>
            </div> -->



            <div class="col-12 mb-3" *ngIf="!boolSpinner">

              <div class="row w-100">
                <div class="col-12 col-md-6 col-lg-4 mb-3 d-flex " *ngFor="let loc of arrayPaginadobd; let i = index">
                  <div class="col-12 rounded shadow-sm bg-white  "   [ngClass]="{
                    'borderLeft1': i % 4 === 0,
                    'borderLeft2': i % 4 === 1,
                    'borderLeft3': i % 4 === 2,
                    'borderLeft4': i % 4 === 3
                  }">
                  <div class="row">
                    <div class="col-10 mb-2 fs12 fw-bold fs13 nunito ps-3">{{loc.strNombre}}</div>
                    <div class="col-2 pt-2">
                      <button class="btn btn-primary py-0 px-2" data-bs-toggle="modal" data-bs-target="#modalComentario" (click)="fnComentarioLugar(loc)">
                        <i class="bi bi-sticky-fill fs13" ></i>
                      </button>
                    </div>
                  </div>
                    <div class="row d-flex w-100 align-items-center">
                      <div class="col-2">
                        <div class="col-12 d-flex">
                          <img class="w-75 mx-auto" src="{{loc.strContenido}}" alt="">
                        </div>
                      </div>  
                      <div class="col-7 d-flex flex-column">
                        <a class="col-12 text-dark tex-decoration-none" [href]="'tel:' + loc.strTelefonoLocal">
                          <mat-icon> phone</mat-icon> {{loc.strTelefonoLocal}}
                        </a>
                        <a class="col-12 text-underline text-primary"  href="{{loc.strurlMaps}}">
                          <mat-icon> place</mat-icon>Ir al lugar.
                        </a>
                      </div>
                      <div class="col-3"  data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="fnInfoPlace(loc)">
                        <div class="col-12 d-flex pointer">
                          <img [src]="'assets/ia/Rb.gif'" class="w-100 mx-auto" alt="">
                        </div>
                      </div>
                    </div>
                    <div class="row align-items-center">
                      <div class="col-12 fs11 text-secondary ps-3 m-2">
                         <span class="">{{loc.strDireccion}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <mat-paginator #paginadorExistentes class="rounded" [length]="arrayProspectosBd.length"
              [pageSize]="pageSizeBD"
              [pageSizeOptions]="[5, 10, 20, 40, 60, 100]"
              (page)="onPageChangeBd($event)">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade show active" id="extraerprosp" role="tabpanel" aria-labelledby="extraerprosp-tab">
        <div class="container pt-3">
          <div class="row"> 
            <div class="col-12 mt-2 mt-md-0 col-md-2 d-flex align-items-center">
              <mat-form-field appearance="outline" class="w-100 bg-white rounded">
                <mat-label>Estados</mat-label>
                <mat-select [(ngModel)]="objEstado" (selectionChange)="fnGetMunicipios()" [disabled]="boolUbcAct">
                  <mat-option value="">--Seleccióne el estado--</mat-option>
                  <mat-option [value]="x" *ngFor="let x of arrayEstados">{{x.estado}}</mat-option>
                </mat-select>
             <!--    <mat-icon matSuffix>location_city</mat-icon> -->
              </mat-form-field>
            </div>
            <div class="col-12 mt-2 mt-md-0 col-md-2 d-flex flex-column">
                <mat-form-field appearance="outline" class="w-100 bg-white rounded">
                    <mat-label>
                      <span>
                        Municipios: {{objEstado && objEstado?.municipios?objEstado?.municipios?.length:0}}
                      </span>
                    </mat-label>
                    <mat-select [(ngModel)]="objMunicipio" [disabled]="boolUbcAct" >
                        <mat-option value="">{{arrayMunicipios.length>0 ? "TODOS": "--Seleccióne el estado--"}}</mat-option>
                        <mat-option value="option3" [value]="mun" *ngFor="let mun of arrayMunicipios" >{{mun.municipio}}</mat-option>
                    </mat-select>
                   <!--  <mat-icon matSuffix>location_city</mat-icon> -->
                </mat-form-field>
            </div>
            
            <div class="col-12 mt-2 mt-md-0 col-md-2">
              <mat-form-field appearance="outline" class="w-100 bg-white rounded">
                <mat-label>Busqueda por Tipo</mat-label>
                <mat-select [(ngModel)]="strTipo" (selectionChange)="onTipoChange($event)">
                    <mat-option value="">{{arrayTipos.length>0 ? "TODOS": "--Seleccióne el tipo--"}}</mat-option>
                    <mat-option value="option3" [value]="km.value" *ngFor="let km of arrayTipos" >{{km.label}}</mat-option>
                </mat-select>
                <mat-icon matSuffix>store_mall_directory</mat-icon>
              </mat-form-field>
            </div>
            <div class="col-12 mt-2 mt-md-0 col-md-2">
              <mat-form-field appearance="outline" class="w-100 bg-white rounded">
                <mat-label>Ingrese Lugar</mat-label>
                <input matInput placeholder="Ingrese Lugar" [(ngModel)]="strKeyword" (ngModelChange)="onKeywordChange($event)">
                <mat-icon matSuffix>work</mat-icon>
              </mat-form-field>
            </div>
            <div class="col-12 mt-2 mt-md-0 col-md-2">
              <mat-form-field appearance="outline" class="w-100 bg-white rounded">
                <mat-label>Kilometros</mat-label>
                <mat-select [(ngModel)]="intKm">
                    <mat-option value="">{{arrayKm.length>0 ? "TODOS": "--Seleccióne el estado--"}}</mat-option>
                    <mat-option value="option3" [value]="km.intKm" *ngFor="let km of arrayKm" >{{km.strNombre}}</mat-option>
                </mat-select>
                <mat-icon matSuffix>gps_fixed</mat-icon>
              </mat-form-field>
            </div>
            <div class="col-12 mt-2 mt-md-0 col-md-1">
              <button class="btn btn-primary d-flex align-items-center" (click)="fnBuscarLug()">
                <mat-icon>search</mat-icon> 
                <span>Buscar</span>  
              </button>
            </div>
          </div>
          <div class="row">
              <div class="col-2">
                <div class="col-12 d-flex mt-3">
                  <button class="btn  fs11 fw-bold w-100 shadow-sm" (click)="obtenerUbicacion()" [ngClass]="{'btn-success':boolUbcAct==true, 'btn-secondary':boolUbcAct==false}">Ubicación Actual</button>
                </div>
                <div class="col-12 d-flex mt-3" *ngIf="boolSelect == false">
                  <button class="btn btn-primary fs11 fw-bold w-100 shadow-sm" (click)="fnSeleccionarTodos()" ><i class="bi bi-check2-all"></i> Seleccionar todo</button>
                </div>
                <div class="col-12 d-flex mt-3" *ngIf="boolSelect == true">
                  <button class="btn btnQuitar fs11 w-100 fw-bold shadow-sm" (click)="fnQuitarTodos()"><i class="bi bi-x-circle-fill"></i> Quitar seleccion</button>
                </div>
                <div class="col-12 d-flex my-3">
                  <button class="btn btnGuardar fs11 w-100 fw-bold shadow-sm" (click)="fnGetGuardarEstablecimientos()"><i class="bi bi-cloud-upload-fill"></i> Guardar</button>
                </div>
              </div>
              <div class="col-10 d-flex justify-content-center mt-2" *ngIf="boolSpinner">
                <mat-spinner></mat-spinner>
              </div>
              <div class="col-10 mt-3 mb-3" *ngIf="!boolSpinner">
              <div class="row w-100">
                <div class="col-12 col-md-6 col-lg-4 mb-3 d-flex position-relative" *ngFor="let loc of arrayPaginadoNuevos; let i = index">
               
                <div class="col-12 rounded shadow-sm bg-white" [ngClass]="{
                    'borderLeft1': i % 4 === 0,
                    'borderLeft2': i % 4 === 1,
                    'borderLeft3': i % 4 === 2,
                    'borderLeft4': i % 4 === 3
                  }">
                  <div class="row">
                    <div class="col-9 mb-2 fs12 fw-bold fs13 nunito ps-3">{{loc.name}}</div>
                    <div class="col-3 d-flex justify-content-end">
                      <input type="checkbox" [(ngModel)]="loc.selectCard" class="form-check fs14 me-2" name="" id="">
                     <!-- <span class="fw-bold"><i class="fa-solid fa-star text-warning"></i> {{loc.rating}}</span>  -->
                    </div>
                  </div>
                    <div class="row d-flex w-100 align-items-center">
                      <div class="col-2">
                        <div class="col-12 d-flex">
                          <img class="w-75 mx-auto" src="{{loc.icon}}" alt="">
                        </div>
                      </div>  
                      <div class="col-7 d-flex flex-column">
                        <a class="col-12 text-primary tex-decoration-none d-flex mb-2" [href]="loc.website"><i class="bi bi-globe me-2"></i><div><span class="fs11">{{loc.website}}</span></div> </a>
                        <a class="col-12 text-dark tex-decoration-none" [href]="'tel:' + loc.formatted_phone_number">
                          <mat-icon> phone</mat-icon> {{loc.formatted_phone_number}}
                        </a>
                        <a class="col-12 text-underline text-primary"  href="{{loc.url}}">
                          <mat-icon> place</mat-icon>Ir al lugar.
                        </a>
                      </div>
                      <div class="col-3"  data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="fnInfoPlace(loc)">
                        <div class="col-12 d-flex pointer">
                          <img [src]="'assets/ia/Rb.gif'" class="w-100 mx-auto" alt="">
                        </div>
                      </div>
                    </div>
                    <div class="row align-items-center">
                      <div class="col-12 fs11 text-secondary ps-3 m-2">
                         <span class="">{{loc.formatted_address}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div class="row mb-3">
                <div class="col-12 position-relative">
                  <mat-paginator #paginadornuevos class="rounded" 
                  [length]="arrayDetails.length"
                  [pageSize]="pageSizeNuevos"
                  [pageSizeOptions]="[5, 10, 20, 40, 60]"
                  (page)="onPageChangeNuevos($event)">
                  </mat-paginator>
                </div>
              </div>
          </div>
        </div>
      </div>
      <!-- <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">...</div> -->
    </div>
  </div>
</div>
</div>
<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title mx-auto mb-0" id="exampleModalLabel">{{strNombreWeb}}</h2>
        <button type="button" class="btn-close ms-0" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
     <!--<div class="row">
          <div class="col-12 d-flex">
            <input type="text" class="form-control me-2" [(ngModel)]="strPregunta">
            <button class="btn btn-primary" (click)="fnia()">Preguntar</button>
          </div>
        </div> -->
        <div class="row my-3 justify-content-center" *ngIf="boolSpinnerModal">
          <mat-spinner>
          </mat-spinner>
        </div>
        <div *ngIf="(!urlWeb || urlWeb== '' ||urlWeb== undefined|| urlWeb == null)&& !boolSpinnerModal">
          <div class="alert alert-danger text-center" role="alert">
            Actualmente, este prospecto no dispone de un sitio web registrado, por lo que no es posible obtener información adicional en línea.
          </div>
        </div>
    <!--     <div class="row" *ngIf="!boolSpinnerModal && strRespuestaiA?.length">
          <div class="col-12">
            <p>
              <span class="fw-bold">Información acerca de la pagina.</span><br>
              <span>{{ strRespuestaiA[1][1] || 'Información no encontrada!' }}</span>
            </p>
          </div>
          <div class="col-12" *ngIf="strRespuestaiA.length > 3 && strRespuestaiA[3] && strRespuestaiA[3][1] && (strRespuestaiA[3][1]['1.4_Telefonos'] || strRespuestaiA[3][1]['1.5_correos_electronicos'])">
            <span class="fw-bold">Contacto:</span>
            <div *ngIf="strRespuestaiA[3][1]['1.4_Telefonos']">
              <h5>Teléfonos:</h5>
              <ul>
                <li *ngFor="let tel of strRespuestaiA[3][1]['Teléfonos']">
                  {{ tel }}
                </li>
              </ul>
            </div>
            <div *ngIf="strRespuestaiA[3][1]['1.5_correos_electronicos']">
              <h5>Correos electrónicos:</h5>
              <ul>
                <li *ngFor="let email of strRespuestaiA[3][1]['1.5_correos_electronicos']">
                  {{ email }}
                </li>
              </ul>
            </div> 
          </div>
          <div class="col-12" *ngIf="strRespuestaiA.length > 4 && strRespuestaiA[4] && strRespuestaiA[4][1]">
            <span class="fw-bold">Directorio Empleados:</span>
            <ul >
              <li *ngFor=" let empl of strRespuestaiA[4][1]">{{empl}}</li>
            </ul>
           
          </div>
        </div> -->
        <div class="row" *ngIf="!boolSpinnerModal && strRespuestaiA && (urlWeb!= '' && urlWeb!= undefined && urlWeb!= null ) ">
          <div class="col-12">
            <p>
              <span class="fw-bold">Información acerca de la página:</span><br>
              <span>{{ strRespuestaiA.tarea_1.descripcion_general || 'Información no encontrada!' }}</span>
            </p>
          </div>
        
          <div class="col-12" *ngIf="strRespuestaiA.tarea_1?.contacto">
            <span class="fw-bold">Contacto:</span>
        
            <div *ngIf="strRespuestaiA.tarea_1.contacto.telefonos?.length">
              <h4 class="fw-bold text-secondary mb-0">Teléfonos:</h4>
              <ul>
                <li *ngFor="let tel of strRespuestaiA.tarea_1.contacto.telefonos">
                  {{ tel }}
                </li>
              </ul>
            </div>
        
            <div *ngIf="strRespuestaiA.tarea_1.contacto.correos?.length">
              <h4 class="fw-bold text-secondary mb-0">Correos electrónicos:</h4>
              <ul>
                <li *ngFor="let email of strRespuestaiA.tarea_1.contacto.correos">
                  {{ email }}
                </li>
              </ul>
            </div>
          </div>
        
          <div class="col-12" *ngIf="strRespuestaiA.tarea_4?.empleados_en_directorios?.length">
            <span class="fw-bold">Directorio de empleados:</span>
            <ul>
              <li *ngFor="let empleado of strRespuestaiA.tarea_4.empleados_en_directorios">
                {{ empleado.nombre }} - {{ empleado.correo }} - {{ empleado.telefono }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="modalComentario" tabindex="-1" aria-labelledby="modalComentarioLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalComentarioLabel">Modal title</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="form-floating">
                <textarea class="form-control" [(ngModel)]="strComentario" placeholder="Leave a comment here" id="floatingTextarea"></textarea>
                <label for="floatingTextarea">Comentario sobre {{objComentario?.strNombre}}</label>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #btnCerarModal>Cerrar</button>
        <button type="button" class="btn btn-primary" (click)="fnSaveComentario()">Guardar</button>
      </div>
    </div>
  </div>
</div>